import GetDigitalAssetRequestModelBase from '../_generated/modelBases/get-digital-asset-request-model-base';

export default class GetDigitalAssetRequestModel extends GetDigitalAssetRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
